import * as actionTypes from './actionTypes';

export const initStaticIPConfig = () => {
  return { type: actionTypes.INIT_STATIC_IP_CONFIG };
};

export const setStaticIPConfig = (staticIPConfigData) => {
  return { type: actionTypes.SET_STATIC_IP_CONFIG, staticIPConfigData };
};

export const fetchStaticIPConfigFailed = () => {
  return { type: actionTypes.FETCH_STATIC_IP_CONFIG_FAILED };
};
